import { HoundNote } from "@/components/HoundNote";

const WOMENS = [
  ["XS", "78–84", "60–66", "84–90"],
  ["S", "84–90", "66–72", "90–96"],
  ["M", "90–96", "72–78", "96–102"],
  ["L", "96–104", "78–86", "102–110"],
  ["XL", "104–112", "86–94", "110–118"],
  ["2XL", "112–120", "94–102", "118–126"],
];

const MENS = [
  ["XS", "86–91", "71–76", "86–91"],
  ["S", "91–97", "76–81", "91–96"],
  ["M", "97–102", "81–86", "96–101"],
  ["L", "102–107", "86–91", "101–106"],
  ["XL", "107–112", "91–97", "106–112"],
  ["2XL", "112–118", "97–104", "112–118"],
  ["3XL", "118–124", "104–111", "118–124"],
];

const DOG_SIZES = [
  ["XS", "20–25", "30–38", "18–22", "Chihuahua, small terriers"],
  ["S", "26–32", "40–48", "22–28", "Dachshund, pug"],
  ["M", "33–40", "50–60", "28–34", "Beagle, basset hound"],
  ["L", "41–48", "62–74", "34–42", "Border collie, boxer"],
  ["XL", "49–58", "76–90", "42–50", "Labrador, golden retriever"],
];

const Table = ({ head, rows, testid }) => (
  <div className="overflow-x-auto rounded-3xl border border-rosegold/15 bg-white" data-testid={testid}>
    <table className="w-full text-left text-sm">
      <thead>
        <tr className="bg-subtle text-maroon">
          {head.map((h) => (
            <th key={h} className="px-5 py-4 font-medium whitespace-nowrap">{h}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {rows.map((r, i) => (
          <tr key={i} className={i % 2 ? "bg-cream/40" : ""}>
            {r.map((c, j) => (
              <td key={j} className={`px-5 py-4 ${j === 0 ? "font-medium text-maroon" : "text-inkbrown/75"}`}>{c}</td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export default function SizeGuide() {
  return (
    <div className="max-w-4xl mx-auto px-5 sm:px-8 py-16">
      <div className="text-center mb-12">
        <p className="text-xs uppercase tracking-[0.25em] text-rosegold mb-3">Find your fit</p>
        <h1 className="font-display text-4xl sm:text-5xl text-maroon">Size Guide</h1>
        <p className="mt-4 text-inkbrown/70 max-w-lg mx-auto">
          A general body-measurement guide (in centimetres) to help you choose. For exact garment
          measurements, please email us directly at{" "}
          <a href="mailto:houndoz@outlook.com" className="text-maroon underline underline-offset-2" data-testid="size-guide-email">houndoz@outlook.com</a>.
          When in doubt, size up for a cosier fit.
        </p>
      </div>

      <HoundNote
        author="George"
        message="If you're stuck between sizes, choose the comfy one. Trust me... naps are serious business."
        className="mx-auto mb-14 -rotate-1"
      />

      <section className="mb-14">
        <h2 className="font-display text-2xl text-maroon mb-5">Women's</h2>
        <Table head={["Size", "Bust (cm)", "Waist (cm)", "Hip (cm)"]} rows={WOMENS} testid="womens-size-table" />
      </section>

      <section className="mb-14">
        <h2 className="font-display text-2xl text-maroon mb-5">Men's</h2>
        <Table head={["Size", "Chest (cm)", "Waist (cm)", "Hip (cm)"]} rows={MENS} testid="mens-size-table" />
      </section>

      <section className="mb-14">
        <h2 className="font-display text-2xl text-maroon mb-5">Dog Apparel</h2>
        <Table head={["Size", "Neck (cm)", "Chest (cm)", "Back length (cm)", "Typical breeds"]} rows={DOG_SIZES} testid="dog-size-table" />
      </section>

      <section className="rounded-3xl bg-subtle p-8">
        <h3 className="font-display text-xl text-maroon mb-4">How to measure your hound</h3>
        <ul className="space-y-3 text-inkbrown/75 leading-relaxed list-disc pl-5">
          <li><strong className="text-inkbrown">Neck:</strong> Measure around the base of the neck where the collar sits.</li>
          <li><strong className="text-inkbrown">Chest:</strong> Measure around the widest part of the chest, just behind the front legs.</li>
          <li><strong className="text-inkbrown">Back length:</strong> Measure from the base of the neck to the base of the tail.</li>
        </ul>
      </section>
    </div>
  );
}
